import { Popover, PopoverContent, PopoverTrigger, Portal } from '@chakra-ui/react';
import { Button, LoaderXs, Panel, Tabs } from '@sketchnote/shared-components';
import * as React from 'react';
import { API, endpoints } from 'src/api';

const { useState, useRef, useCallback } = React;

export const UploadImage = ({
  onSubmit,
  button,
  disableModal = false,
  isReadOnly = false,
}: {
  onSubmit: (url: string) => void;
  button: JSX.Element;
  disableModal?: boolean;
  isReadOnly?: boolean;
}) => {
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [isLoading, setIsLoading] = useState(false);
  const toggleMenu = (value?: boolean) => () => {
    setIsOpenMenu(value ?? !isOpenMenu);
  };
  const handleOnOpenDialog = () => {
    inputRef.current?.click();
  };

  const onUploadImage: React.ChangeEventHandler<HTMLInputElement> = async (e) => {
    const files = e.target?.files?.[0];
    setIsOpenMenu(false);
    setIsLoading(true);

    const data = new FormData();
    files && data.append('file', files);
    const fileURL = await API.put('/file', data, {
      headers: { ['Content-Type']: 'multipart/form-data' },
    });
    if (fileURL) {
      onSubmit(fileURL.data);
      setIsOpenMenu(false);
      setIsLoading(false);
    }
  };

  return (
    <Popover
      placement="bottom"
      isOpen={isOpenMenu}
      onOpen={toggleMenu(true)}
      onClose={toggleMenu(false)}
      modifiers={[{ name: 'eventListeners', options: { scroll: isOpenMenu } }]}
    >
      <PopoverTrigger>
        <button disabled={isReadOnly}>
          {isLoading ? (
            <div className="ml-8">
              <LoaderXs />
            </div>
          ) : (
            <>{button}</>
          )}
        </button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent>
          {!isLoading ? (
            <div className="flex flex-col p-16 rounded-lg bg-white shadow-sm text-gray-999 min-w-400">
              <Tabs selected={0} size="small" className="border-b">
                <Panel title="Upload">
                  <div className="my-16">
                    <input
                      id="editor-image-upload"
                      ref={inputRef}
                      type="file"
                      accept="image/*"
                      name="image"
                      alt="upload image"
                      hidden
                      onChange={onUploadImage}
                    />
                    <Button onClick={handleOnOpenDialog} className="justify-center w-full">
                      Choose an Image
                    </Button>
                  </div>
                </Panel>
              </Tabs>
            </div>
          ) : null}
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
